export class Province {
  provinceName?: string;
  status?: boolean;
  id: number;
  isUseForStatistics?: boolean
}
